export default {
  plural: 'Изображения',
  singular: 'Изображение'
};
